function getRestErrorCode(err: any): string | null {
  try {
    return err.error.code;
  } catch {
    return null;
  }
}

function getGraphqlErrorCode(error: any): string | null {
  try {
    return error.graphQLErrors[0].extensions.code;
  } catch (ignored) {
    return null;
  }
}

export function getErrorCode(error: any): string | null {
  return getGraphqlErrorCode(error) || getRestErrorCode(error);
}

